<template>
  <div>
    <div class="white-background list-top-margin" >
      <!-- 面包屑导航 -->
      <div class="page-top">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>自定义配置</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span style="color:#000;font-weight:bold;">出库单</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
        <el-row class="tbl-btn">
          <el-col :span="12" class="tbl-btn-left">
            <el-button size="small" type="primary" icon="el-icon-plus" @click="createProduct">添加新字段</el-button>
            <div style="display: inline-block;">
              <span style="color:rgb(155, 155, 155);font-size:14px;margin-left:5px;">
                <i class="el-icon-warning message-icon"></i>
                <span>最多支持添加80个字段</span>
              </span>
            </div>
          </el-col>
          <!-- <el-col :span="12" class="tbl-btn-right">
            <el-button type="default" size="small" icon="el-icon-s-operation">列配置</el-button>
          </el-col> -->
        </el-row>
        <!--列表-->
        <el-table
          size="small"
          :data="listData"
          highlight-current-row
          v-loading="loading"
          stripe
          border
          :header-cell-style="_headerStyle"
          element-loading-text="加载中"
          style="width: 100%;"
        >
          <el-table-column align="left" type="index" width="50" label="序号"></el-table-column>
          <el-table-column  prop="fieldName" label="字段名称">

          </el-table-column>
          <el-table-column label="字段类型" >
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.fieldType" placement="top">
                <span class="txt-overflow">{{scope.row.fieldType}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="creater" label="创建人" ></el-table-column>
          <el-table-column prop="createTime" label="创建时间" ></el-table-column>
          <el-table-column prop="updateTime" label="更新时间" ></el-table-column>

          <el-table-column align="left" label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-tooltip content="编辑">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  circle
                  @click="edit(scope.$index, scope.row)"
                ></el-button>
              </el-tooltip>


              <el-tooltip content="删除">
                <el-popconfirm title="确认删除？" @confirm="Delete(scope.$index, scope.row)">
                    <el-button
                        size="mini"
                        type="danger"
                        icon="el-icon-delete"
                        circle
                        slot="reference"
                    ></el-button>
                 </el-popconfirm>


              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination>
    </div>
    <AddField  :fieldData="fieldData" @save="productSave"  :diaVisible="createProductPanVisible"></AddField>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import AddField from '@/views/customSetting/production/addField';
import {queryCustomSet,addUptCustomSet,delCustomSet} from '@/api/business';
export default {
  name: "outTicket",
  components:{
      Pagination,
      AddField,
  },
  data() {
    return {
        listData: [],
        loading: false,
        form:{
           condition: {
              collection: "outstock",
              factoryId: ""
            },
            currentPage: 1,
            pageSize: 10,
        },
        // 分页参数
        pageparm: {

            currentPage: 1,
            pageSize: 10,
            total: 0
        },
        createProductPanVisible:false,
        fieldData:{},
        user:JSON.parse(window.localStorage.getItem('userdata')),

    };
  },
  created() {
    this.form['condition']['factoryId'] = this.user['factoryId'];
    this.getList();
  },
  methods: {

    getList(){
       this.loading = true;

      queryCustomSet(this.form).then(res=>{
       this.loading = false;

        if(res['code'] == 200){
            this.pageparm = res['data'];
            this.listData = res['data']['list'];
        }
      })
    },

     // 分页插件事件
    callFather(parm) {

        this.form['currentPage'] = param['currentPage'];
        this.form['pageSize'] = param['pageSize'];
        this.getList();
    },
    createProduct(){
      this.fieldData = {},
      this.createProductPanVisible = true;
    },
    productSave(val){
        if(val){
          val['factoryId'] = this.user['factoryId'];
          val['creater'] = this.user.name + '(' + this.user.account + ')';
          val['collection'] = this.form['condition']['collection'];
          addUptCustomSet(val).then(res=>{

            if(res['code']==200){
              this.$message({
                type: 'success',
                message: '操作成功！'
              });
            }else{
              this.$message.error(res['msg'] || '操作失败！');
            }
            this.getList();
          })

        }
        this.createProductPanVisible =false;

    },
    Delete(index,row){
        delCustomSet(row['_id']).then(res=>{
          if(res['code'] == 200){
               this.$message({
                type: 'success',
                message: '操作成功！'
              });
          }else{
              this.$message.error(res['msg'] || '操作失败！');
          }
          this.getList();
        })
    },
    edit(index,row){
      this.fieldData = row;
      this.createProductPanVisible = true;
    }

  }
};
</script>
<style scoped>
.page-top {
  height: 30px;
  line-height: 30px;
}
.el-breadcrumb {
  line-height: 15px;
}
.page-row {
  /* background-color: #efefef; */
}
.page-row .el-tabs__nav-wrap::after {
  height: 0px;
}
.page-row .el-tabs__header {
  margin: 0px;
}

.user-search {
  margin-top: 20px;
}

.el-divider__text {
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
.tbl-pagination {
  text-align: right;
}
.tbl-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
}
.tbl-btn .tbl-btn-right {
  text-align: right;
}
.el-divider--horizontal {
  margin: 10px 0px;
}
.el-form-item {
  margin-bottom: 20px;
}
.search-row .half-width {
  width: calc(100% - 132px);
  margin-left: 8px;
}
.search-row .input-number {
  width: calc(50% - 5px);
}
</style>



// WEBPACK FOOTER //
// src/views/customSetting/outTicket/outTicket.vue